import { useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Lock, Loader2, Plane, FileDown } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SharedItinerary() {
  const { shareId } = useParams();
  const [password, setPassword] = useState("");
  const [html, setHtml] = useState(null);
  const [title, setTitle] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const open = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/public/itineraries/${shareId}`, { password });
      setHtml(data.html);
      setTitle(data.title);
    } catch (err) {
      setError(err.response?.status === 401 ? "Incorrect password." : "This itinerary is not available.");
    } finally {
      setLoading(false);
    }
  };

  const downloadPdf = () => {
    window.open(`${API}/public/itineraries/${shareId}/export.pdf?password=${encodeURIComponent(password)}`, "_blank");
  };

  if (html) {
    return (
      <div className="min-h-screen bg-slate-100">
        <div className="sticky top-0 z-10 bg-white border-b border-slate-200 px-6 h-14 flex items-center justify-between">
          <div className="font-heading font-bold text-slate-900 truncate">{title}</div>
          <Button size="sm" onClick={downloadPdf} className="bg-blue-600 hover:bg-blue-700 text-white" data-testid="share-download-pdf"><FileDown className="h-4 w-4 mr-1.5" /> Download PDF</Button>
        </div>
        <iframe title="itinerary" data-testid="shared-view" srcDoc={html} className="w-full" style={{ height: "calc(100vh - 56px)", border: "none" }} />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-3 mb-8">
          <div className="h-10 w-10 rounded-lg bg-blue-600 flex items-center justify-center"><Plane className="h-5 w-5 text-white -rotate-45" /></div>
          <div className="font-heading font-extrabold text-xl text-slate-900 tracking-tight">Your itinerary</div>
        </div>
        <div className="rounded-lg border border-slate-200 bg-white p-6">
          <div className="inline-flex items-center gap-2 text-slate-900 font-medium mb-1"><Lock className="h-4 w-4 text-blue-600" /> Password protected</div>
          <p className="text-sm text-slate-500 mb-4">Enter the password your travel agent shared with you.</p>
          <form onSubmit={open} className="space-y-3">
            <div>
              <Label htmlFor="pw">Password</Label>
              <Input id="pw" data-testid="share-view-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1" />
            </div>
            {error && <div data-testid="share-view-error" className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2">{error}</div>}
            <Button data-testid="share-view-open" type="submit" disabled={loading} className="w-full bg-blue-600 hover:bg-blue-700 text-white">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "View itinerary"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
